export const ROTATION = {
  albumSize: 1.168,
  albumDepth: 0.013,
  albumGeometryScale: 3.5,
  activeDuration: 700,
  hoverDropDuration: 400,
  hoverLiftDuration: 1000,
  introStagger: 75,
  mobileIntroStagger: 161,
  wallFadeDuration: 1000,
  albumFadeDuration: 400,
  scaleDuration: 150,
  topShelfCount: 4,
  shelfRotation: -0.26,
  hoverOffset: 0.125,
  thudDelay: 1098,
} as const
export function shelfPosition(
  index: number,
  mobile = false,
): [number, number, number] {
  if (mobile)
    return [((index % 2) - 0.5) * 1.38, 1.45 - Math.floor(index / 2) * 1.53, 0]
  return index < 4
    ? [(index - 1.5) * 1.33, 0.835, 0]
    : [(index - 6) * 1.33, -0.66, 0]
}
